import dynamic from 'next/dynamic'
import { RangeInputProps } from './RangeInput'

export const DynamicRangeInput = dynamic<RangeInputProps>(() =>
  import('./RangeInput').then(
    (md) => md.RangeInput as React.FC<RangeInputProps>
  )
)
